<template>
  <standard-layout>
    <template #heading><h1>Impressum</h1></template>
    <template #main>
      <div class="row">
        <div class="col-12 col-md-4">
          <h5>So erreichst Du uns</h5>
          SPABoot<br/>
          Nicole Kempe<br/>
          Hafenstraße 1<br/>
          04463 Großpösna<br/>
          <a :href="'tel:' + $store.getters.configuration.phone">
            <font-awesome-icon icon="mobile-alt"/>&nbsp;{{ $store.getters.configuration.phone }}</a>.
          <span class="d-md-none">
            <cld-image public-id="email.png" size="36%"/>
          </span>
          <span class="d-none d-md-flex">
            <cld-image public-id="email.png" size="80%"/>
          </span>
          <router-link :to="{name: 'contact'}">
            <button class="btn btn-primary mt-2">
              Kontakt aufnehmen
            </button>
          </router-link>
        </div>
        <div class="col-12 col-md-8 mt-3 mt-md-0">
          <GettingThere/>
        </div>
        <div style="margin-top: 2rem">
          <LeaderBanner/>
        </div>
        <div>
          <h1>Impressum:</h1>
          <p>
            <strong>Firma</strong><br>
            Nicole Kempe<br>
            Hafenstraße 1<br>
            04463 Großpösna<br>
            Telefon/Mobil: +49 (0) 151-61890071<br>
            Mail: (siehe oben)<br>
            <strong>USt.-ID DE366583868</strong>
          </p>

          <p>
            <strong>Hinweis zur Online-Streitbeilegung gemäß Art. 14 Abs. 1 ODR-VO:</strong> Die Europäische Kommission
            stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die Sie unter <a
              href="http://ec.europa.eu/consumers/odr/">http://ec.europa.eu/consumers/odr/</a> finden.
          </p>

          <p>
            Wir sind bereit an Streitbeilegungsverfahren vor einer Schlichtungsstelle
            teilzunehmen.
          </p>

          <p>
            <strong>Zuständige Schlichtungsstelle ist die:</strong><br>
            Allgemeine Verbraucherschlichtungsstelle<br>
            des Zentrums für Schlichtung e.V.<br>
            Straßburger Straße 8<br>
            77694 Kehl am Rhein<br>
            <a href="https://www.universalschlichtungsstelle.de/">https://www.universalschlichtungsstelle.de/</a>
          </p>

          <h2>Allgemeines</h2>
          <p>
            Als seriöser Anbieter und Dienstleister sind wir bestrebt, uns stets redlich, richtig und gesetzeskonform zu
            verhalten. Unter diesem Gesichtspunkt wurde auch unsere Website erstellt. Alle Inhalte, Erklärungen,
            Verlinkungen und sonstigen Informationen wurden nach bestem Wissen und Gewissen erstellt.
          </p>

          <h2>Haftung für Inhalte</h2>
          <p>
            Diese Website und ihre Inhalte wurden von uns mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit,
            Vollständigkeit und Aktualität der Inhalte wird jedoch keine Gewähr übernommen.
          </p>

          <p>
            Laut Gesetz obliegt uns die Verantwortung für eigene Inhalte. Uns trifft jedoch keine Verpflichtung,
            übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf
            rechtswidriges Verhalten bzw. rechtswidrige Tätigkeiten hinweisen. Dies trifft nicht auf explizite
            gesetzliche Verpflichtungen zur Entfernung bzw. Sperrung von Informationen zu. Vor dem Zeitpunkt der
            Kenntnis einer konkreten Rechtsverletzung ist jedoch keine Haftung möglich. Sollte uns eine solche
            Verletzung zur Kenntnis gelangen, werden wir die betroffenen Inhalte unverzüglich entfernen.
          </p>

          <h2>Haftung für Links</h2>
          <p>
            Unsere Internetpräsenz enthält Links zu externen Webseiten Dritter. Auf deren Inhalte haben wir natürlich
            keinen Einfluss, weshalb wir keine Gewähr für den Inhalt dieser Seiten übernehmen können. Für die
            entsprechenden Inhalte ist der jeweilige Betreiber respektive der Anbieter der Seiten allein verantwortlich.
            Als wir die Verlinkungen gesetzt haben, haben wir alle entsprechenden Seiten mit größter Sorgfalt auf
            etwaige Verstöße geprüft. Solche Verstöße bzw. rechtswidrige Inhalte lagen zum Zeitpunkt der Überprüfung
            nicht vor. Eine Verpflichtung zur permanenten inhaltlichen Kontrolle dieser verlinkten Seiten wäre ohne
            konkreten Anhaltspunkt einer Rechtsverletzung unzumutbar und kann uns daher nicht treffen. Sollten wir
            allerdings Kenntnis einer Rechtsverletzung erlangen, werden wir die Verlinkung umgehend entfernen.
          </p>

          <h2>Urheberrecht</h2>
          <p>
            Die durch uns erstellten Inhalte und Werke auf diesen Seiten unterliegen allesamt dem deutschen
            Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
            Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Die
            Nutzung unserer Internetpräsenz oder deren Inhalte für kommerzielle Zwecke, ist nur nach vorheriger
            Genehmigung durch uns möglich. Wir behalten uns ausdrücklich das Recht vor, bestimmte kommerzielle Nutzungen
            zu untersagen. Inhalte Dritter auf dieser Seite, die nicht vom Betreiber erstellt wurden, werden unter
            Beachtung der jeweiligen Urheberrechte verwendet und entsprechend als solche gekennzeichnet. Sollten Sie
            trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir Sie höflichst um einen
            entsprechenden Hinweis. Sobald uns etwaige Rechtsverletzungen bekannt werden, werden wir alle nötigen
            Schritte unternehmen, diese sofort und dauerhaft zu unterlassen, bzw. dafür Sorge zu tragen, dass solche
            unterbleiben.
          </p>

          <h2>Datenschutz</h2>
          <p>
            Bei alle Handlungen rund um den Kaufvertrag werden von uns Daten erhoben, gespeichert und
              verarbeitet. Die gesetzlichen Bestimmungen werden dabei von uns beachtet.
          </p>

          <p>
            Während Sie unsere Website aufrufen, werden Ihre IP-Adresse, der Browsertyp und Datum und Uhrzeit
              Ihres Besuches protokolliert. Auch werden die Art Ihres Betriebssystems und die besuchten Seiten von uns
              gespeichert. Ein Zugriff auf personenbezogene Daten ist damit nicht möglich.
          </p>

          <p>
            Personenbezogenen Daten, die Sie uns bei einer Bestellung, Anmeldung zum Newsletter, per E-Mail oder
              Kontaktformular mitteilen, werden nur für den Zweck verarbeitet und benutzt, zu dem Sie uns die Daten
              aktiv zur Verfügung gestellt haben.
          </p>

          <p>
            Ihre Daten müssen von uns natürlich an das entsprechende Versandunternehmen weitergegeben werden,
              falls Sie eine Warenlieferung erhalten sollen. Auch geben wir Ihre Zahlungsdaten gegebenenfalls an das mit
              der Zahlung beauftragte Kreditinstitut weiter.
          </p>

          <p>
            Darüber hinaus werden Ihre personenbezogenen Daten nicht an Dritte weitergeben.
          </p>

          <p>
            Personenbezogene Daten werden so lange gespeichert, bis der Zweck erfüllt ist, zu dem Sie diese uns
            mitgeteilt haben. Gesetzliche Pflichten verlängern die Speicherung der Daten gegebenenfalls auf bis zu 10
            Jahre.
          </p>

          <p>
            Sie können jederzeit die Löschung, Korrektur, die Einschränkung der Verarbeitung oder eine komplette
            Sperrung Ihrer persönlichen Daten, sofern gesetzlich möglich, veranlassen. Auf Wunsch erhalten Sie
            unentgeltlich Auskunft über alle personenbezogenen Daten, die durch uns gespeichert worden sind. Diese
            stellen wir Ihnen dann in einem üblichen Dateistandard zum Zwecke der Übertragung zur Verfügung.
          </p>

          <p>
            Die Rechtsgrundlage der Datenverarbeitung ergibt sich aus Art. 6 – EU-DSGVO.
          </p>

          <p>
            Bei allen Unstimmigkeiten haben Sie das Recht sich bei der zuständigen Aufsichtsbehörde zu beschweren. Diese
            erreichen Sie unter:
          </p>

          <p>
            <strong>Der Sächsische Datenschutzbeauftragte</strong><br>
            Anschrift: Bernhard-von-Lindenau-Platz 1, 01067 Dresden<br>
            Postfach 12 09 05, 01008 Dresden<br>
            Telefon: 0351 493 - 5401<br>
            Telefax: 0351 493 - 5490<br>
            E-Mail: <a href="mailto:saechsdsb@slt.sachsen.de">saechsdsb@slt.sachsen.de</a><br>
            Internet: <a href="http://www.datenschutz.sachsen.de">http://www.datenschutz.sachsen.de</a>
          </p>

          <p>
            <strong>Bei allen Anliegen rund um den Datenschutz wenden Sie sich bitte an:</strong>
          </p>

          <p>
            <strong>Firma</strong><br>
            Nicole Kempe<br>
            Hafenstraße 1<br>
            04463 Großpösna<br>
            Telefon/Mobil: +49 (0) 151-61890071<br>
            Mail: (siehe oben)<br>
            <strong>USt.-ID DE366583868</strong>
          </p>

          <p>
            Wir weisen ausdrücklich darauf hin, dass jede Datenübertragung im Internet (z. B. bei der Kommunikation per
            E-Mail) Sicherheitslücken aufweisen kann. Ein umfassender Schutz der Daten vor einem Zugriff durch Dritte
            ist nicht möglich.
          </p>

          <p>
            Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung
            von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich
            widersprochen. Als Betreiber der Seiten behalten wir uns ausdrücklich rechtliche Schritte im Falle der
            unverlangten Zusendung von Werbeinformationen, etwa durch Spam-E-Mails, vor.
          </p>

          <hr>

          <p>
            <small>Dieses Impressum wurde von <a href="http://www.christophbecker.org">Rechtsanwalt Christoph Becker</a>
              erstellt.</small>
          </p>
        </div>
      </div>
    </template>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";
import GettingThere from "@/components/GettingThere";
import LeaderBanner from "@/components/LeaderBanner";

export default {
  components: {
    LeaderBanner,
    GettingThere,
    StandardLayout
  }
}
</script>
